(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/brand-mapping/assets/javascripts/brands/product/bomben.js') >= 0) return;  svs.modules.push('/components/lb-utils/brand-mapping/assets/javascripts/brands/product/bomben.js');
"use strict";

let products;
if (svs.isServer) {
  products = require('@svenskaspelab/trinidad-core').core.components.require('utils', 'products');
} else {
  products = svs.utils.products;
}

const _products = products,
  getDisplayName = _products.getDisplayName,
  getProductClassName = _products.getProductClassName,
  productIds = _products.productIds;

const model = {
  brand: getProductClassName(productIds.BOMBEN),
  displayName: getDisplayName(productIds.BOMBEN),
  brandLogo: 'bomben',
  brandMenuColor: 'white'
};
const toExport = model;

if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.lbUtils.brandMapping.brands.product.bomben', toExport);
}


 })(window);